import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const Container = styled.div`
  min-height: 250px;
  height: auto;
  padding: 21px 39px 30px 17px;
  background: ${Colors.background_secondary};
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  width: 406px;
  max-width: 100vw;
  margin-bottom: 36px;
  // margin-right: 31px;
  align-items: center;
  @media (max-width: 1390px) {
    width: 100%;
  }
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  margin: -21px -39px 21px -17px;
  height: 42px;
  display: flex;
  align-items: center;
  padding-left: 17px;
  color: ${Colors.text_on_primary};
  background: ${Colors.BG_Header_Card};
`;

const RoundColor = styled.div`
  height: 9.4px;
  min-height: 9.4px;
  width: 9.4px;
  min-width: 9.4px;
  border-radius: 50%;
  margin-right: 8.6px;
`;

const PaymentTypeText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  align-items: center;
  color: ${Colors.text_dark};
`;

const ContainerColorPaymentType = styled.div`
  display: flex;
  align-items: center;
`;

const Money = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  align-items: center;
  color: ${Colors.text_dark};
`;

const MoneyLine = styled.div`
  border-top: 1px solid ${Colors.divider};
  ${(props) => props.last && `border-bottom: 1px solid ${Colors.divider};`}
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 26px;
  padding-right: 23px;
  padding-bottom: 17px;
  padding-top: 17px;
`;

const NoItemsContainer = styled.div`
  height: 180px;
  display: grid;
  align-items: center;
`;

const NoItemsMessageCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${Colors.text_secondary};
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  text-align: center;
`;

export default {
  Container,
  Title,
  RoundColor,
  PaymentTypeText,
  ContainerColorPaymentType,
  Money,
  MoneyLine,
  NoItemsContainer,
  NoItemsMessageCenter,
};
